// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__7-H96","innerContainer":"PageNotFound_innerContainer__qk2wH","texts":"PageNotFound_texts__QhLXg"};